<template>
    <ion-grid @click="onclick">
        <ion-row>
            <ion-label>{{ address.name }}</ion-label>
        </ion-row>
        <ion-row>
            <ion-label>{{ address.company }}</ion-label>
        </ion-row>
        <ion-row>
            <ion-label>{{ address.street }}</ion-label>
        </ion-row>
        <ion-row>
            <ion-label>{{ address.postalCode }} {{ address.city }} {{ address.district ? ('(' + address.district + ')') : ''}}</ion-label>
        </ion-row>
        <ion-row v-if="false">
            <ion-label>{{ address.district }} {{ address.country }}</ion-label><!-- "Bezirk Schöneberg" "DE-BE" -->
        </ion-row>
    </ion-grid>
</template>

<script setup lang="ts">
import {IonGrid, IonLabel, IonRow} from '@ionic/vue';
import {Address} from "@/graphql/generated/graphql";
import {StartNavigation} from "@cwoebker/capacitor-start-navigation"
import {Capacitor} from "@capacitor/core";

const props = defineProps<{
        address: Address
    }>()

const onclick = () => {
    if (!Capacitor.isNativePlatform()) {
        console.warn('StartNavigation.launchMapsApp not supported', props.address)
        return
    }
    StartNavigation.launchMapsApp({address:{
            street: props.address.street || null,
            city: props.address.city || null,
            state: null,
            postalCode: props.address.postalCode || null,
            country: props.address.country?.startsWith('DE') ? 'Deutschland' : null
        }})
}

</script>

<style scoped>
    ion-grid {
        padding: 0;

        color: var(--ion-color-medium); /* used ony in JobsiteDetails, where everythin is medium*/
    }
</style>
